import {UseQueryResult, useQuery} from '@tanstack/react-query';
import IWBrokerClient from '../client/IWBrokerClient';
import {gatewayUserScopedQueryOptions} from './gatewayQueryUtils';

export function useUserQuery(userId: number): UseQueryResult<Record<string, any>, Error> {
    return useQuery<Record<string, any>>({
        queryKey: ['user', userId],
        enabled: !!userId,
        queryFn: async () => IWBrokerClient.request('user', {userId}) as Promise<Record<string, any>>,
        ...gatewayUserScopedQueryOptions,
        staleTime: 1000 * 60 * 5
    });
}
